export function sendStoredEvent() {
  const match = document.cookie.match(/(?:^|; )acc_dl_event=([^;]+)/);
  if (match) {
    const eventName = decodeURIComponent(match[1]);
    if (eventName) {
      trackDataLayerEvent(eventName, false);
      // clear the cookie
      document.cookie = 'acc_dl_event=; Path=/; Max-Age=0';
    }
  }
}

export function trackDataLayerEvent(eventName, oneTime = true) {
  const eventKey = `gtm_event_${eventName}`;

  if (oneTime && sessionStorage.getItem(eventKey)) return;

  dataLayer.push({
    'event': eventName
  });

  if(oneTime) sessionStorage.setItem(eventKey, '1');
}